import { useEffect } from 'react';
import { isProduction } from 'utils/env/isProduction';

export const Dashboard = () => {
	useEffect(() => {
		window.location.replace(isProduction ? '/panel/dashboard' : `${process.env.REACT_APP_PANEL_HOST}/dashboard`);
	}, []);

	return null;
};
export default Dashboard;
